import { crmmApi } from 'dashboard/helper/crmmApi';
export async function kbPost(path, body) {
  return crmmApi(path, body);
}
